import SlotGameModel from "Engine/slots/model/SlotGameModel";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import ErrorsManager from "Base/ErrorsManager";
import RelaxModel from "Base/model/RelaxModel";

export default new class GameModel extends SlotGameModel {
    constructor() {
        super();

        this.wilds = [];
        this.freeBets = [];
    }

    checkStartSpin() {
        if (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets) {
            GlobalDispatcher.dispatch('model:startSpin');
            return true;
        }

        if (!this.isFreeSpins) {
           this._freeSpins = null;
        }

        if (this.balance >= this.totalBet) {
            GlobalDispatcher.dispatch('model:startSpin');
            this.balance -= this.totalBet;
            return true;
        } else {
            //console.log('noMoney');
            GlobalDispatcher.dispatch('model:noMoney');
            //ErrorsManager.getError({errorCode:506});

            let popupData = {
                title: {
                    text: 'error_title'
                },
                message: {
                    text: 'error_506'
                },
                type: 'message'
            };
            GlobalDispatcher.dispatch('popupContainer:showPopup', popupData);

            if (this.isAutoPlay) {
                this.isAutoPlay = false;
            }
            return false;
        }
    }

    setNewData(data) {
        super.setNewData(data);
        if (data.wilds && data.wilds.length > 0) {
            data.wilds.forEach((wildData)=>{
                wildData.bet = this.bet;
            });
            this.wilds = data.wilds;
        } else {
            this.wilds = [];
        }

        this.freeBets = data.freeBets;
    }
}
